<div class="summary-cards-container">
  <!-- Erste Kachel: Current Selection -->
  <div class="summary-card" style="margin-top: 0">
    <ng-container
      *ngIf="
        hasInitializedProductValues;
        then publisherSelected;
        else noValuesTemplate
      "
    >
    </ng-container>
    <ng-template #publisherSelected>
      <div>
        <span class="summary-headline">Overview</span>
      </div>
      <div class="summary-content">
        <!-- Strukturierte Darstellung nach Kategorien mit Gruppennamen -->
        <ng-container *ngFor="let categoryName of getCategoriesInOrder()">
          <!-- Kategorie-Header -->
          <div class="category-header">{{ categoryName }}</div>

          <!-- Items in dieser Kategorie -->
          <div
            *ngFor="let item of getItemsByCategory()[categoryName]"
            [class.changed]="item.changed"
            [class.deactivated]="
              item.currentValue === 'DEACTIVATED_BY_PRINTED_ENDSHEET'
            "
            class="summary-row"
          >
            <span
              class="field-label"
              [class.specialEffects-label]="
                item.key === 'selectedSpecialEffects'
              "
              >{{ item.label }}</span
            >
            <div class="field-value-container">
              <span
                [class.strikethrough]="
                  item.currentValue === 'DEACTIVATED_BY_PRINTED_ENDSHEET'
                "
                [class.specialEffects-value]="
                  item.key === 'selectedSpecialEffects'
                "
                class="field-value"
              >
                {{ getDisplayValue(item) }}
              </span>
              <span
                *ngIf="item.changed"
                id="value-changed-icon-{{ item.uniqueLabel }}"
                style="display: flex"
              >
                <i class="dx-icon-info value-changed-icon"></i>
              </span>
              <dx-tooltip
                [hideOnOutsideClick]="false"
                hideEvent="mouseleave"
                position="top"
                showEvent="mouseenter"
                target="#value-changed-icon-{{ item.uniqueLabel }}"
              >
                <div *dxTemplate="let data = data; of: 'content'">
                  Default Value {{ item.defaultValue }}
                </div>
              </dx-tooltip>
            </div>
          </div>
        </ng-container>
      </div>
    </ng-template>
    <ng-template #noValuesTemplate>
      <div *ngIf="hasInitializedPublisher" class="no-values-message">
        <div class="no-values-headline">Please select a product</div>
        <div class="no-values-description">
          To begin your cost calculation, please select a product. Additional
          options will unlock once your selection is made.
        </div>
      </div>

      <div *ngIf="!hasInitializedPublisher" class="no-values-message">
        <div class="no-values-headline">Please select a publisher</div>
        <div class="no-values-description">
          Once a publisher is selected, preconfigured products are unlocked for
          selection
        </div>
      </div>
    </ng-template>
  </div>
</div>
